<template>
	<b-modal id="modal-1" ref="statusDialogModal" title="Cloud Status" size="xl" centered hide-footer :modal-class="theme">
		<table class="table">
			<thead>
				<tr>
					<th scope="col">Name</th>
					<th scope="col">URI</th>
					<th scope="col">Service Health</th>
					<th scope="col">Service version</th>
					<th scope="col">UI Health</th>
					<th scope="col">UI Version</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="service in services" :key="service.id">
					<td>{{ service.name }}</td>
					<td>{{ service.uri }}</td>
					<td v-if="service.be == 'UP'" :title="service.build_date_be">
						<span class="running">
							<div class="icon-tick"></div>
							Up
						</span>
					</td>
					<td v-if="service.be == 'DOWN'">
						<span class="down">
							<div class="icon-error"></div>
							Down
						</span>
					</td>
					<td v-if="service.be == 'DEGRADED'">
						<span class="degraded">
							Degraded
						</span>
					</td>
					<td v-if="service.tag_be" :title="service.commit_be">{{ service.tag_be }}</td>
					<td v-if="!service.tag_be">
						<span class="down">
							<div class="icon-error"></div>
							Unknown
						</span>
					</td>
					<td v-if="service.fe == 'UP'" :title="service.build_date_fe">
						<span class="running">
							<div class="icon-tick"></div>
							Up
						</span>
					</td>
					<td v-if="service.fe == 'DOWN'">
						<span class="down">
							<div class="icon-error"></div>
							Down
						</span>
					</td>
					<td v-if="service.fe == 'N/A'">
						No UI for this service
					</td>
					<td v-if="service.tag_fe" :title="service.commit_fe">{{ service.tag_fe }}</td>
					<td v-if="!service.tag_fe">
						<span class="down">
							<div class="icon-error"></div>
							Unknown
						</span>
					</td>

				</tr>
			</tbody>
		</table>
	</b-modal>
</template>

<script>
import ThemeService from "../../services/theme";
import { mapGetters } from "vuex";

export default {
	name: "StatusDialog",
	data: function () {
		return {
			theme: 'light'
		};
	},
	created() {
		this.theme = ThemeService.instance().getTheme() || 'light';
		this.listenForThemeChanges();
	},
	methods: {
		open: function () {
			this.$refs.statusDialogModal.show();
		},
		listenForThemeChanges: function () {
			ThemeService.instance().events.on("themechanged", () => {
				this.theme = ThemeService.instance().getTheme();
			});
		},
	},
	computed: {
		...mapGetters({
			services: 'serviceHealth'
		})
	}
};
</script>

<style>
.table {
	margin-top: 20px;
}
.icon-error,
.icon-tick {
	width: 24px;
	height: 24px;
	margin-right: 10px;
}
.running,
.down {
	display: flex;
	align-items: center;
}
.light .running {
	color: #35b052;
}
.light .down {
	color: #f74557;
}
.light .degraded {
	color: #d95402;
}
.dark .running {
	color: #35b052;
}
.dark .down {
	color: #f74557;
}
.dark .degraded {
	color: #ff6200;
}
td {
	vertical-align: middle !important;
	padding: 0.75rem 1rem !important;
}
</style>
